import { addDays, isAfter, isBefore, subDays } from 'date-fns'
import React, { ReactNode } from 'react'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'

export function BonusIssueRow({ issue }: { issue: IssueEntity }) {
    let bonusIssueContent: ReactNode = null
    const publicationDate = issue.publicationDate ? new Date(issue.publicationDate) : null

    if (!issue.bonusIssues || issue.bonusIssues.length === 0 || !publicationDate) {
        return null
    }

    const outcomePm = issue.sources.find((source) => source.sourceType === 'Outcome')
    const endComparisonDateBase = outcomePm ? new Date(outcomePm.publishedDate) : publicationDate
    const startComparisonDate = subDays(publicationDate, 30)
    const endComparisonDate = addDays(endComparisonDateBase, 30)

    const bonusIssueWithinTimeFrame = issue.bonusIssues.find(
        (bonusIssue) =>
            isAfter(new Date(bonusIssue.changeDate), startComparisonDate) &&
            isBefore(new Date(bonusIssue.changeDate), endComparisonDate),
    )

    if (bonusIssueWithinTimeFrame) {
        const { changeDate, newShares, oldShares } = bonusIssueWithinTimeFrame
        const oldSharesLabel = oldShares > 1 ? 'befintliga aktier' : 'befintlig aktie'
        const newSharesLabel = newShares > 1 ? 'nya aktier' : 'ny aktie'

        if (newShares > oldShares) {
            bonusIssueContent = `Fondemission genomförd den ${changeDate} där ${oldShares} ${oldSharesLabel} gav ${newShares} ${newSharesLabel}`
        }
    }

    return bonusIssueContent ? <FactsTableRow label='Fondemission'>{bonusIssueContent}</FactsTableRow> : null
}
